import { render, staticRenderFns } from "./eidtBaseInfo.vue?vue&type=template&id=ff1fbb5e&scoped=true&"
import script from "./eidtBaseInfo.vue?vue&type=script&lang=js&"
export * from "./eidtBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./eidtBaseInfo.vue?vue&type=style&index=0&id=ff1fbb5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1fbb5e",
  null
  
)

export default component.exports